<!-- 由 suu 创建于 2026-06-03 星期三 -->
<template>
  <div class="contact-menu">
    <div class="menu-wrapper">
      <!-- 商务合作 -->
      <!-- <div class="menu-item" @click="handleBusinessCooperation">
        <span class="label">商务合作</span>
        <span class="value">wchhywizd(微信号)</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div> -->

      <!-- 内容合作 -->
      <div class="menu-item" @click="handleContentCooperation">
        <span class="label">内容合作</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div>

      <!-- 商城客服 -->
      <div class="menu-item" @click="handleStoreService">
        <span class="label">商城客服</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div>

      <!-- 健萌健身客服(长沙) -->
      <div class="menu-item" @click="handleGymService('changsha')">
        <span class="label">健萌健身客服(长沙)</span>
        <span class="value">联系客服</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div>

      <!-- 健萌健身客服(江苏) -->
      <div class="menu-item" @click="handleGymService('jiangsu')">
        <span class="label">健萌健身客服(江苏)</span>
        <span class="value">联系客服</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div>

      <!-- 健萌健身客服(深圳) -->
      <div class="menu-item" @click="handleGymService('shenzhen')">
        <span class="label">健萌健身客服(深圳)</span>
        <span class="value">联系客服</span>
        <van-icon name="arrow" class="arrow-icon" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 联系我们菜单页面
 * @description 展示各类客服和合作联系方式，支持复制微信号和页面跳转
 */
export default {
  name: 'ContactMenu',

  data() {
    return {
      // 商务合作微信号
      businessWechat: 'wchhywizd',
      // 商城客服链接 - 测试环境
      storeServiceUrlTest:
        'https://t.weimob.com/Bh_NvLb&fromType=11&isLogin=1&title=客服',
      // 商城客服链接 - 正式环境
      storeServiceUrlProd:
        'https://t.weimob.com/Bl_Nvwe&fromType=11&isLogin=1&title=客服'
    }
  },

  methods: {
    /**
     * @description 处理商务合作点击 - 复制微信号
     */
    handleBusinessCooperation() {
      // 使用 clipboard 复制
      const input = document.createElement('input')
      input.value = this.businessWechat
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$toast('复制成功')
      } catch (err) {
        this.$toast('复制失败')
      }
      document.body.removeChild(input)
    },

    /**
     * @description 处理内容合作点击 - 跳转内容合作页面
     */
    handleContentCooperation() {
      this.$router.push('/contact-us')
    },

    /**
     * @description 处理商城客服点击 - APP路由跳转
     * 根据环境判断使用测试或正式链接
     */
    handleStoreService() {
      const env = this.$http.getEnv()
      // Prod 环境使用正式链接，其他环境使用测试链接
      const url =
        env === 'Pro' ? this.storeServiceUrlProd : this.storeServiceUrlTest
      const route = `/wmOtherPage?url=${url}`
      this.$betterwe.jumpRoute(route)
    },

    /**
     * @description 处理健萌健身客服点击
     * @param {string} type - 客服类型：changsha|jiangsu|shenzhen
     */
    handleGymService(type) {
      const typeMap = {
        changsha: '',
        jiangsu: '?type=3',
        shenzhen: '?type=4'
      }
      const query = typeMap[type] || ''
      this.$router.push(`/wegymer-consult-wx${query}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.contact-menu {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  padding: vw(16);
  padding-bottom: calc(#{vw(16)} + constant(safe-area-inset-bottom));
  padding-bottom: calc(#{vw(16)} + env(safe-area-inset-bottom));
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;

  .menu-wrapper {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: vw(8);
    overflow: hidden;
  }

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: vw(48);
    padding: 0 vw(16);
    background: #ffffff;
    cursor: pointer;

    &:active {
      background: #f9f9f9;
    }

    .label {
      font-size: vw(14);
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: vw(22);
    }

    .value {
      flex: 1;
      text-align: right;
      font-size: vw(14);
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: vw(20);
      margin-right: vw(4);
    }

    .arrow-icon {
      font-size: vw(12);
      color: #cccccc;
    }
  }
}
</style>
